"use strict";
// tslint:disable:no-any
Object.defineProperty(exports, "__esModule", { value: true });
exports.findIndex = void 0;
/**
 * Returns the first index in the array in which the element satisfies the provided testing function.
 * Otherwise -1 is returned if no elements satisfy it.
 * Wraps around array and starts at the given startIndex.
 */
var findIndex = function (array, testingFn, startIndex, thisArg) {
    if (startIndex === void 0) { startIndex = 0; }
    for (var i = startIndex; i < array.length + startIndex; i++) {
        var index = i % array.length;
        if (testingFn.call(thisArg, array[index], index)) {
            return index;
        }
    }
    return -1;
};
exports.findIndex = findIndex;
//# sourceMappingURL=FindIndex.js.map